import {Component, Inject, OnInit} from '@angular/core';
import {Observable} from 'rxjs';

import {ActivatedRoute, Params} from '@angular/router';
import {map} from 'rxjs/operators';
import {ProjectStatusModel} from './project.status.model';
import {SuppliersService} from '../../../services/suppliers.service';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {SearchPositionDialogComponent} from '../search-position/search.position.dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {CoreService, OrdersService, Param, ProleisObject} from "@proleis/proleis-rest-client";
import {BreakpointService, CurrentViewService, LoadingService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-project-status',
  templateUrl: 'project.status.component.html'
})
export class ProjectStatusComponent implements OnInit {

  pos$: Observable<ProleisObject>;
  pbo: ProleisObject;
  projectStatus$: Observable<ProjectStatusModel[]>;
  index = 0;
  size = 0;
  currentStatus: ProjectStatusModel;
  previousStatus: ProjectStatusModel;
  changedStatus: ProjectStatusModel;
  mobile: boolean;
  change = false;
  params: Params;

  constructor(private activatedRoute: ActivatedRoute, private coreService: CoreService, private currentViewService: CurrentViewService,
              private breakpointService: BreakpointService, private suppliersService: SuppliersService,
              private notificationService: NotificationService, private ordersService: OrdersService,
              @Inject(APP_GUIDS) private guids: AppGuids, private loadingService: LoadingService, private matDiag: MatDialog) {
  }

  ngOnInit() {
    this.breakpointService.isSmall().subscribe(mobile => {
      this.mobile = mobile;
    });

    this.params = this.activatedRoute.snapshot.params;

    this.pos$ = this.suppliersService.getPosition(this.params.id, this.params.posId);
    this.ordersService.getPurchaseOrder(this.params.id, 'CHANNELGUID=CHANNEL_ID.GUID').subscribe(pbo => {
      this.pbo = pbo;
    });
    this.projectStatus$ = this.loadProjectStatus(this.params.id, this.params.posId);
    this.projectStatus$.subscribe();
    this.updateCurrentAndPreviousStatus();
  }

  loadProjectStatus(pboId: string, pseId: string): Observable<ProjectStatusModel[]> {
    return this.suppliersService.getProjectStatus(pboId, pseId);
  }

  updateCurrentAndPreviousStatus() {
    this.projectStatus$.pipe(
      map(status => {
        this.size = status.length;
        status.sort((a, b) => {
          if (a.TIMELABEL < b.TIMELABEL) {
            return 1;
          } else if (a.TIMELABEL > b.TIMELABEL) {
            return -1;
          } else {
            return 0;
          }
        });
        this.currentStatus = status[this.index];
        this.previousStatus = status[this.index + 1];
      })
    ).subscribe();
  }

  increment() {
    ++this.index;
    this.updateCurrentAndPreviousStatus();
  }

  decrement() {
    --this.index;
    this.updateCurrentAndPreviousStatus();
  }

  onChange(status: ProjectStatusModel) {
    this.change = this.index === 0;
    this.changedStatus = status;
  }

  saveChanges() {
    delete this.changedStatus.OBJECT_ID;
    this.suppliersService.updateProjectStatus(
      this.params.id, this.params.posId, String(this.changedStatus.PROJECT_INFO_ID), this.changedStatus
    ).subscribe(result => {
      this.currentViewService.setLoading(false);
      this.notificationService.showNotification('Projektstatus gespeichert');
    }, error => {
      this.currentViewService.setLoading(false);
      this.notificationService.showNotification('Fehler beim Speichern des Projektstatus');
    });

    this.change = false;
  }

  insertProjectStatus() {
    this.loadingService.setBlocking('projektstatus', true, 'Projektstatus wird angelegt...');
    const emptyParams: Param[] = [];
    this.coreService.executeAction<ProjectStatusModel>(
      this.params.posId, '§b02fe89c-2c51-11b2-8016-cb6d12b1d0f5', emptyParams
    ).subscribe(result => {
      this.notificationService.showNotification('Projektstatus angelegt');
      this.projectStatus$ = this.suppliersService.getProjectStatus(this.params.id, this.params.posId);
      this.projectStatus$.subscribe();
      this.loadingService.setBlocking('projektstatus', false, '');
      this.updateCurrentAndPreviousStatus();
    }, error => {
      this.notificationService.showError(error.error);
      this.loadingService.setBlocking('projektstatus', false, '');
    });
  }

  isInternal(): boolean {
    return this.pbo.CHANNELGUID === this.guids.GUID_CHANNEL_INTERNAL;
  }

  openSearchDialog() {
    this.matDiag.open(SearchPositionDialogComponent);
  }
}
